module.exports = __webpack_public_path__ + "img/image77.071fbcac.png";